import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { ChevronDown, ChevronUpOutline } from '@lyearn/icons';

function useSeeMoreList<T>(items: T[], defaultShowCount: number) {
  const { t } = useTranslation();
  const [showAll, { toggle }] = useToggle(false);

  const { buttonText, endIcon } = showAll
    ? { buttonText: t('Common:ShowLess'), endIcon: <ChevronUpOutline className="-ms-6" /> }
    : { buttonText: t('Common:ShowMore'), endIcon: <ChevronDown className="-ms-6" /> };

  const shouldShowMore = items.length > defaultShowCount;
  const itemsToShow = shouldShowMore && !showAll ? items.slice(0, defaultShowCount) : items;

  return { shouldShowMore, showAll, itemsToShow, buttonText, endIcon, toggle };
}

export default useSeeMoreList;
